<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Gyártók</span>
          <el-button
            v-can="'data.manufacturer.create'"
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            icon="el-icon-plus"
            @click="$router.replace('/data/manufacturers/add')"
          >
            Új gyártó
          </el-button>
        </div>
        <table-filter
          v-if="config"
          :config="config"
          action="manufacturer/fetchAllWithPagination"
        />
        <list />
        <template v-if="$route.meta.showAddManufacturerDialog">
          <manufacturer-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateManufacturerDialog">
          <manufacturer-dialog
            :manufacturer-id="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/products/Sidebar';
  import List from '../../../components/data/products/manufacturers/List';
  import ManufacturerDialog from '../../../components/data/products/manufacturers/Dialog';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      ManufacturerDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    async mounted() {
      await this.setConfig();
    },
    methods: {
      async setConfig() {
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
        ];
      }
    }
  };
</script>
